/*
 *  search form
 */

var events = window.nffleet_events;

function GetSearchForm(inputPlaceholder) {
    var emptyString = "";

    var divTag = "div";
    var formTag = "form";
    var inputTag = "input";
    var svgTag = "svg";
    var pathTag = "path";
    var svgNs = "http://www.w3.org/2000/svg";

    var searchFormWrapper = document.createElement(divTag);
    searchFormWrapper.classList.add("page-search");

    var searchForm = document.createElement(formTag);
    searchForm.action = "";
    searchForm.autocomplete = "off";
    searchFormWrapper.appendChild(searchForm);

    var searchIconSvg = document.createElementNS(svgNs, svgTag);
    searchIconSvg.setAttributeNS(null, "width", 24);
    searchIconSvg.setAttributeNS(null, "height", 24);
    searchIconSvg.setAttributeNS(null, "viewBox", "0 0 17.159 18.907");
    searchIconSvg.setAttributeNS(null, "class", "page-search-icon");
    searchForm.appendChild(searchIconSvg);

    var searchIconSvgPath = document.createElementNS(svgNs, pathTag);
    searchIconSvgPath.setAttributeNS(null, "d", "M17.006,17.27l-5.141-5.41C13.122,10.601,13.9,8.865,13.9,6.95C13.9,3.118,10.782,0,6.95,0C3.118,0,0,3.118,0,6.95c0,3.832,3.118,6.95,6.95,6.95c1.184,0,2.299-0.299,3.275-0.823c0.026,0.056,0.049,0.091,0.049,0.091l5.331,5.607c0,0,0.711,0.414,1.267-0.224S17.006,17.27,17.006,17.27z M1.5,6.95c0-3.005,2.445-5.45,5.45-5.45c3.005,0,5.45,2.445,5.45,5.45c0,3.005-2.445,5.45-5.45,5.45C3.945,12.4,1.5,9.955,1.5,6.95z");
    searchIconSvg.appendChild(searchIconSvgPath);

    var searchFormInputField = document.createElement(inputTag);
    searchFormInputField.id = "search-input-field";
    searchFormInputField.name = "query";
    searchFormInputField.type = "text";
    searchFormInputField.placeholder = inputPlaceholder;
    searchForm.appendChild(searchFormInputField);

    var searchFormInputButton = document.createElement(inputTag);
    searchFormInputButton.id = "search-submit";
    searchFormInputButton.classList.add("page-search-submit");
    searchFormInputButton.type = "submit";
    searchForm.appendChild(searchFormInputButton);
    
    searchFormInputButton.addEventListener("click", function (event) {
        if (searchFormInputField.value === undefined || searchFormInputField.value === emptyString) {
            event.preventDefault();
            searchFormWrapper.dispatchEvent(event.destroy());
        }
    });

    searchFormInputField.addEventListener("keydown", function (event) {
        if (event.keyCode === 13 && (this.value === undefined || this.value === emptyString)) {
            event.preventDefault();
            searchFormWrapper.dispatchEvent(event.destroy());
        }

        if (event.keyCode === 27) {
            searchFormWrapper.dispatchEvent(event.destroy());
        }
    });

    searchFormInputField.focus();

    return searchFormWrapper;
}

window.nffleet_searchForm = GetSearchForm;